// extracted by mini-css-extract-plugin
export default {"CardSquareContainer":"news_CardSquareContainer__f-A5n"};